import { Component } from '@angular/core';

@Component({
  selector: 'vb-theme-settings',
  templateUrl: './theme-settings.component.html',
  styleUrls: ['./theme-settings.component.scss'],
  standalone: false  //NOSONAR
})
export class ThemeSettingsComponent {}
